export class LicenceDocument {
    public effectiveDate;
    public expiryDate;
    public documentId;
    public docBasePath: string = "";
    public docExtType: string = "";
    public docFullPath: string = "";
    public docGUID: string = "";
    public docNameWithExtension: string = "";
}
